import React, { useEffect } from 'react'

import './remessa-pagamento-item.scss'
import _ from 'lodash'
import { Card } from 'primereact/card'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button'
import { DataTable } from 'primereact/datatable'
import { icons } from '../../../constants'
import { formatarData, formatarDinheiro } from '../../../utils/index'
import utils from '../../../utils'

export default function RemessaPagamentoItem(props) {
  useEffect(() => {}, [])

  const columns = [
    {
      field: 'beneficiario',
      header: utils.getMessage(props.messages, 'remessapagamento.label.beneficiario'),
      columnKey: 'beneficiario',
      sortable: false,
      filter: false,
    },
    {
      field: 'taxa',
      header: utils.getMessage(props.messages, 'remessapagamento.label.taxa'),
      columnKey: 'taxa',
      sortable: false,
      filter: false,
    },
    {
      field: 'codigoBarras',
      header: utils.getMessage(props.messages, 'remessapagamento.label.codigoBarras'),
      columnKey: 'codigoBarras',
      sortable: false,
      filter: false,
    },
    {
      field: 'valor',
      header: utils.getMessage(props.messages, 'remessapagamento.label.valor'),
      columnKey: 'valor',
      sortable: false,
      filter: false,
    },
    {
      field: 'dataVencimento',
      header: utils.getMessage(props.messages, 'remessapagamento.label.dataVencimento'),
      columnKey: 'dataVencimento',
      sortable: false,
      filter: false,
    },
    {
      field: 'acoes',
      header: utils.getMessage(props.messages, 'remessapagamento.label.acoes'),
      columnKey: 'acoes',
    },
  ]

  const resolveColumns = () => {
    return columns.map((col) => {
      col.showFilterMenuOptions = false
      col.showClearButton = false
      col.showFilterMenu = false

      if (col.field === 'beneficiario' || col.field === 'taxa') {
        return (
          <Column
            {...col}
            key={col.field}
            body={formatColumn}
            bodyClassName="column-beneficiario-body-width"
            headerClassName="column-beneficiario-header-width"
            filterHeaderClassName="column-beneficiario-filter-header-width"
          />
        )
      }

      if (col.field === 'codigoBarras') {
        return (
          <Column
            {...col}
            key={col.field}
            body={formatColumn}
            bodyClassName="column-codigo-barras-body-width"
            headerClassName="column-codigo-barras-header-width"
            filterHeaderClassName="column-codigo-barras-filter-header-width"
          />
        )
      }

      if (col.field === 'valor') {
        return (
          <Column
            {...col}
            key={col.field}
            body={formatColumn}
            bodyClassName="column-valor-body-width"
            headerClassName="column-valor-header-width"
            filterHeaderClassName="column-valor-filter-header-width"
            alignHeader={'right'}
          />
        )
      }

      if (col.field === 'dataVencimento') {
        return (
          <Column
            {...col}
            key={col.field}
            body={formatColumn}
            bodyClassName="column-vencimento-body-width"
            headerClassName="column-vencimento-header-width"
            filterHeaderClassName="column-vencimento-filter-header-width"
          />
        )
      }

      if (col.field === 'acoes') {
        return (
          <Column
            {...col}
            key={col.field}
            body={actions}
            bodyClassName="column-actions-servico-body-width"
            headerClassName="column-actions-servico-header-width"
            filterHeaderClassName="column-actions-servico-filter-header-width"
          />
        )
      }
      return null
    })
  }

  const actions = (rowData) => {
    return (
      <div>
        <Button
          type="button"
          icon={icons.REMOVE_ICON}
          className="p-button-danger"
          onClick={(e) => removeItem(e, rowData)}
        />
      </div>
    )
  }

  const removeItem = (e, data) => {
    e.preventDefault()
    e.stopPropagation()
    props.onClickRemoveItem(data)
  }

  const formatColumn = (rowData, column) => {
    const field = _.get(column, 'field', '')
    if (field === 'beneficiario') {
      return _.get(rowData, 'beneficiario.value', null)
    }
    if (field === 'taxa') {
      return _.get(rowData, 'taxa.value', null)
    }
    if (field === 'codigoBarras') {
      return _.get(rowData, 'codigoBarras', null)
    }
    if (field === 'valor') {
      return formatarDinheiro(_.get(rowData, 'valor', 0))
    }
    if (field === 'dataVencimento') {
      return formatarData(_.get(rowData, 'dataVencimento', ''))
    }
    return null
  }

  return (
    <React.Fragment>
      <Card title={utils.getMessage(props.messages, 'remessapagamento.label.itens')}>
        <div className="p-grid form-group" style={{ marginTop: '15px' }}>
          <div className="p-col-12">
            <DataTable
              emptyMessage=" "
              value={props.values}
              resizableColumns={true}
              columnResizeMode="expand"
              filterDisplay="row"
              size={'small'}
              stripedRows={true}
              responsiveLayout="scroll"
              scrollable={true}
              scrollHeight="400px"
            >
              {resolveColumns()}
            </DataTable>
          </div>
        </div>
      </Card>
    </React.Fragment>
  )
}
